import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";

type RoadmapModalProps = {
	title: string;
	open: boolean;
	children: React.ReactNode;
	handleOpenChange(open: boolean): void;
};

export function RoadmapModal({
	title,
	open,
	handleOpenChange,
	children,
}: RoadmapModalProps) {
	return (
		<Dialog open={open} onOpenChange={handleOpenChange}>
			<DialogContent className="max-w-3xl">
				<DialogHeader>
					<DialogTitle className="text-2xl">{title}</DialogTitle>
				</DialogHeader>
				{children}
			</DialogContent>
		</Dialog>
	);
}
